import { Component, OnInit } from "@angular/core";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "app-short-courses",
  templateUrl: "./short-courses.component.html",
  styleUrls: ["./short-courses.component.css"],
})
export class ShortCoursesComponent implements OnInit {
  roleId: any = localStorage.getItem("RoleId");
  constructor(public CommonService: CommonService) {
    // this.roleId = atob(this.roleId);
    this.CommonService.decrypt$(localStorage.getItem("RoleId")).subscribe(value => {
      this.roleId = value;
    });
  }

  ngOnInit(): void {}
}
